export default __webpack_public_path__ + "static/media/ellipsis.c981bbdc.svg";